import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import currencyFormatter from '@sprinx/formatting/currencyFormatter';
import ProductPriceElementBase from '../ProductPriceElementBase';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {},
      price: {},
      label: {},
      labelEnd: {},
      labelStart: {}
    }
  );
}, {
  name: 'SxComProductPriceElementPrice'
});

function ProductPriceElementPrice(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? ProductPriceElementBase : _ref$component,
      currency = _ref.currency,
      decoration = _ref.decoration,
      labelEnd = _ref.labelEnd,
      labelStart = _ref.labelStart,
      size = _ref.size,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "color", "component", "currency", "decoration", "labelEnd", "labelStart", "size", "value"]);

  var classes = useStyles({
    classes: pClasses
  });
  var formattedPrice = React.useMemo(function () {
    return value !== undefined ? currencyFormatter(value, currency) : undefined;
  }, [currency, value]);
  return formattedPrice ? /*#__PURE__*/React.createElement(Component, _extends({
    classes: classes,
    className: clsx(classes.root, className),
    currency: currency,
    formattedValue: formattedPrice,
    decoration: decoration,
    color: color,
    size: size,
    labelStart: labelStart,
    labelEnd: labelEnd
  }, rest), formattedPrice) : null;
}

ProductPriceElementPrice.propTypes = {
  classes: PropTypes.shape({
    label: PropTypes.string,
    price: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  component: PropTypes.elementType,
  currency: PropTypes.string.isRequired,
  decoration: PropTypes.oneOf(['none', 'strike']),
  labelEnd: PropTypes.node,
  labelStart: PropTypes.node,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  value: PropTypes.number
};
ProductPriceElementPrice.defaultProps = {
  classes: undefined,
  className: undefined,
  color: 'initial',
  component: undefined,
  decoration: 'none',
  labelEnd: undefined,
  labelStart: undefined,
  size: 'medium',
  value: undefined
};
export default ProductPriceElementPrice;